import { useMutation } from '@tanstack/react-query';
import { useDialogs, useNotifications } from '@toolpad/core';
import { useNavigate } from 'react-router';
import {
    Card,
    CardContent,
    CardHeader,
    Stack,
    Typography,
} from '@mui/material';
import Button from '@mui/material/Button';

import Api from '@barboxx/api';
import { BusinessServingContainer } from '@barboxx/models';

interface Props {
    servingContainer: BusinessServingContainer.DetailsResponse;
}

export const ServingContainerDeleteCard = ({ servingContainer }: Props) => {
    const notification = useNotifications();
    const navigate = useNavigate();
    const dialog = useDialogs();

    const mutateDeleteServingContainer = useMutation({
        mutationKey: ['deleteServingContainer', servingContainer.id],
        mutationFn: () =>
            Api.BusinessSpecific.ServingContainer.deleteServingContainer(
                servingContainer
            ),
    });

    const onDelete = async () => {
        const deleteConfirmed = await dialog.confirm(
            'Are you sure you want to Delete this serving container!',
            {
                severity: 'error',
                okText: 'Delete',
                title: 'Delete Serving container',
            }
        );

        if (!deleteConfirmed) {
            return;
        }

        mutateDeleteServingContainer
            .mutateAsync()
            .then(({ data }) => {
                notification.show('Deleted serving container!', {
                    severity: 'success',
                });
                navigate(-1);
            })
            .catch(e => {
                notification.show('Error Deleting serving container!', {
                    severity: 'error',
                });
            });
    };

    return (
        <Card>
            <CardHeader title="Delete ServingContainer" />
            <CardContent>
                <Stack gap={2} direction="row">
                    <Typography flex={1}>
                        Are you sure you want to Delete this serving container?
                    </Typography>

                    <Button onClick={onDelete} color="error" variant="outlined">
                        Delete
                    </Button>
                </Stack>
            </CardContent>
        </Card>
    );
};
